<template>
  <v-footer
    class="text-center d-flex flex-column"
    style="
      background: linear-gradient(to top, #dfe9f3 0%, white 100%);
      padding: 50px;
    "
  >
    <div>
      <a
        v-for="icon in icons"
        :key="icon"
        :href="icon.url"
        style="color: black"
        target="_blank"
      >
        <v-btn class="mx-4 icono" :icon="icon.icon" variant="text"></v-btn>
      </a>
    </div>

    <div class="pt-0 m-5">
      Fullstack Developer. IAM Consultant. Systems Analyst graduated from ORT
      Argentina. I consider myself a responsible and hard-working person. If I
      don't know something, I learn it. If I don't understand something, I
      consult it. I always receive good feedback from my teammates, both
      students and work. Broad stack of knowledge on user interface processes,
      testing, debugging and troubleshooting.
    </div>

    <v-divider></v-divider>

    <div>
      {{ new Date().getFullYear() }} —
      <strong style="color: #42b983">Valentino Indovino</strong>
    </div>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      { icon: "mdi-github", url: "http://github.com/valenindovino" },
      { icon: "mdi-linkedin", url: "http://linkedin.com/in/valentinoindovino" },
      { icon: "mdi-instagram", url: "http://instagram.com/valenindovino" },
    ],
  }),
};
</script>

<style scoped>
.icono:hover {
  color: #42b983;
  transition: 0.3s;
}

a {
  text-decoration: none;
}
</style>
